import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  infoBox: {
    backgroundColor: '#e3f2fd',
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
  },
  iconSpacing: {
    marginRight: theme.spacing(1),
  },
}));

interface InfoAlertProps {
  infoText: string;
  className?: string;
  icon?: React.ElementType;
  iconClassName: string;
}

const InfoAlert: React.FC<InfoAlertProps> = ({ infoText, className, icon: Icon = InfoOutlined, iconClassName }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.infoBox} ${className || ''}`}>
      <Icon className={`${classes.iconSpacing} ${iconClassName || ''}`} />
      <Typography>{infoText}</Typography>
    </div>
  );
};

export default InfoAlert;
